export default [
  {
    path: '/notificationList', // 通知中心
    name: 'notificationList',
    component: () => {
      return import(
        /* webpackChunkName: "messagecenter" */ '@/views/messagecenter/index.vue'
      )
    }
  },
  {
    path: '/notificationDetail', // 通知中心
    name: 'notificationDetail',
    component: () => {
      return import(
        /* webpackChunkName: "messagecenter" */ '@/views/messagecenter/notificationDetail.vue'
      )
    }
  },
  {
    path: '/mymessage', // 我的消息
    name: 'myMessage',
    component: () => {
      return import(
        /* webpackChunkName: "messagecenter" */ '@/views/messagecenter/mymessage.vue'
      )
    }
  }
]
